import { SubscriptionMetaOut } from '../../../store/api';
import { ManageSubscriptionsHeader } from '../types/ManageSubscriptionsHeader';
import { TFunction } from 'i18next';

export const mapHeader = (meta: SubscriptionMetaOut, t: TFunction): ManageSubscriptionsHeader => {
    const { currentSubscriptionPeriod, nextSubscriptionPeriod } = meta;

    const currentYearSubscriptionPeriodStartDate = t('dateFormat.dateWithMonth', {
        val: new Date(currentSubscriptionPeriod?.startDate)
    });
    const currentYearSubscriptionPeriodEndDate = t('dateFormat.dateWithMonth', {
        val: new Date(currentSubscriptionPeriod?.endDate)
    });
    const nextYearSubscriptionPeriodStartDate = t('dateFormat.dateWithMonth', {
        val: new Date(nextSubscriptionPeriod?.startDate)
    });
    const nextYearSubscriptionPeriodEndDate = t('dateFormat.dateWithMonth', {
        val: new Date(nextSubscriptionPeriod?.endDate)
    });

    return {
        showAllLabel: meta.includesSharedCopies ? t('shop.subscriptions.showAllCopies') : undefined,
        currentYearSubscriptionPeriodLabel: `${currentYearSubscriptionPeriodStartDate} - ${currentYearSubscriptionPeriodEndDate}`,
        nextYearSubscriptionPeriodLabel: `${nextYearSubscriptionPeriodStartDate} - ${nextYearSubscriptionPeriodEndDate}`
    };
};
